export default {
  SET_MODULE_BESTSELLER(state, payload) {
    state.bestseller = payload;
  },
  SET_MODULE_ENDORSEMENT(state, payload) {
    state.endorsement = payload;
  },
};
